/* eslint-disable react/destructuring-assignment */
import Tooltip from '@deprecated-ui/common/Tooltip';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { Company } from '../../../../../../../../@types/company';
import { Checkbox, SearchItemContainer } from './styled';
import CompanyIcon from '../components/CompanyIcon';

const TooltipContent = () => (
  <>
    <Text size="12px" height="18px">
      Maximum 25 stocks
    </Text>
  </>
);

type AddCheckboxProps = {
  isSelected: boolean;
  isDisabled: boolean;
}

const AddCheckbox = ({ isSelected, isDisabled }: AddCheckboxProps) => (
  <Tooltip
    title={isDisabled ? <TooltipContent /> : false}
    overlayInnerStyle={{
      background: color.light,
      padding: '8px 16px',
      border: `1px solid ${color.downgray}`,
    }}
    overlayClassName="tooltip-overlay-transparent"
    placement="bottom"
  >
    <Checkbox isDisabled={isDisabled}>
      {isSelected ? (
        <Image src="/icon/rt-company-checkmark.svg" class="selected" />
      ) : <Image src="/icon/rt-company-add.svg" class="add" />}
    </Checkbox>
  </Tooltip>
  );

interface ISearchItem extends Company {
  isSelected: boolean;
  isDisabled: boolean;
  hasCheckbox: boolean;
  onSelect: (symbol: string) => void;
  onRemove: (symbol: string) => void;
}

const SearchItem = (props: ISearchItem) => {
  const {
    name: symbolName,
    symbol_2: symbol,
    desc,
    onSelect,
    onRemove,
    isSelected,
    isDisabled,
    hasCheckbox,
  } = props;

  const handleClickCheckbox = () => {
    if (isSelected) {
      onRemove(`${symbol}#${symbolName}`);
    } else {
      onSelect(`${symbol}#${symbolName}`);
    }
  };

  return (
    <SearchItemContainer
      onClick={isDisabled && !isSelected ? null : handleClickCheckbox}
      // @ts-expect-error
      isDisabled={isDisabled && !isSelected}
    >
      <CompanyIcon symbol={symbol} />
      <Text
        weight="700"
        width="52px"
        ellipsis
      >
        {symbol}
      </Text>
      <Text
        width={hasCheckbox ? '150px' : '180px'}
        ellipsis
      >
        {desc}
      </Text>
      {hasCheckbox && (
        <AddCheckbox
          isSelected={isSelected}
          isDisabled={isDisabled && !isSelected}
        />
      )}
    </SearchItemContainer>
  );
};

export default SearchItem;
